export default () => ({
  init() {
    this.$watch('password', (to) => {
      let score = 0
      if(to.length >= 8) {
        score++
      }
      if(/[A-Z]/.test(to)) {
        score++
      }
      if(/[a-z]/.test(to)) {
        score++
      }
      if(/\d/.test(to)) {
        score++
      }
      if(/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(to)) {
        score++
      }

      if(score >= 5) {
        this.strength = 'Strong'
      } else {
        this.strength = 'Weak'
      }
    })
  },
  password: '',
  strength: 'Weak',
  affiliation: '',
  aircrafts: [],
  addAircraft() {
    this.aircrafts.push({
      type: '',
      model: '',
      serial_number: '',
      registration_number: '',
    })
  },
  removeAircraft(index) {
    this.aircrafts.splice(index, 1)
  },
})
